import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mto_component_hdr_RowClass} from '../../../dbschema';

export class MTOComponentHdrContainerModel extends BaseContainerModel {

  bl_fi_mto_component_hdr: bl_fi_mto_component_hdr_RowClass = new bl_fi_mto_component_hdr_RowClass();
}
